export namespace VoteEnum {
    export enum Type {
        Not_Voted = 3, // 100000000,
        Approved = 1,
        Rejected = 2,
    }

    export enum member {
        Panel = 1,
        Board = 2
    }

    export class Convert {
        static getEnum(ordinal): Type {
            switch (ordinal) {
               // case 100000000:
               case 3:
                case 'Not Voted':
                    return Type.Not_Voted;
                case 1:
                case 'Approved':
                    return Type.Approved;
                case 2:
                case 'Rejected':
                    return Type.Rejected;
                default:
                    return Type.Not_Voted;
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/vote.enum.ts